import axios from 'axios'
import config from '../config'
import {getDoctorToken} from '../utils'

const resetPasswordApi = async (params) => {
    const response = await axios({
        url: `${config.api.base_url}doctor/resetPassword`,
        method:"patch",
        data:params,

        
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getDoctorToken()}`

           
        }
    })
    console.log(params);

    return response

}

export default resetPasswordApi